import 'bootstrap'
import { choicesConfiguration, Dialog } from "./utility.mjs"
import Choices from "choices.js"

let patente;
$(() => {
    patente = new Choices($("#patenteGuida")[0], choicesConfiguration($("#locale").val()));

    clear_fields(true);

    $("#cv").on("change", () => {
        const data = new FormData();
        
        data.append('file', $('#cv')[0].files[0]);

        let request;
        Dialog.fire({
            html: `<div>${$("#elabora").val()}</div><div class="d-flex justify-content-around overflow-hidden mt-3"><div class="swal2-loader" style="display: block"></div></div>`,
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: true,
            showConfirmButton: false
        }).then(result => {
            if (result.isDismissed)
                request?.abort();
        });

        request = $.ajax({
            url: 'read_cv',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            method: 'POST',
            success: data => {
                clear_fields();

                if(!data) {
                    Dialog.close();
                    return;
                }

                $("#nome").val(data["nome"]);
                $("#cognome").val(data["cognome"]);
                $("#dataNascita").val(data["data_nascita"]);
                $("#luogoNascita").val(data["luogo_nascita"]);
                $("#provinciaNascita").val(data["provincia_nascita"]);
                $("#luogoResidenza").val(data["citta_residenza"]);
                $("#indirizzoResidenza").val(data["indirizzo_residenza"]);
                $("#capResidenza").val(data["cap_residenza"]);
                $("#provinciaResidenza").val(data["provincia_residenza"]);
                $("#telefono").val(data["telefono"]);
                $("#email").val(data["email"]);
                $("#automunito").val(data["automunito"] ? "true" : "false");
                if(data["patente_guida"])
                    patente.setChoiceByValue(data["patente_guida"].split(","));
                $("#titoloStudio").val(data["titolo_studio"]);
                $("#qualifica").val(data["qualifica"]);        
                $("#istituto").val(data["istituto"]);
                
                ["italiano", "inglese", "tedesco", "francese", "spagnolo"].forEach(l => {
                    const livello_parlato = data[l + "_parlato"];
                    const livello_scritto = data[l + "_scritto"];

                    const id_parlato = `${l}_parlato_${livello_parlato}`;
                    const id_scritto = `${l}_scritto_${livello_scritto}`;

                    $(`#${id_parlato}`).prop("checked", true);
                    $(`#${id_scritto}`).prop("checked", true);
                });
                
                Dialog.close();
            },
            error: xhr => {
                if (xhr.statusText === 'abort') return;
                if(xhr.status == 413) {
                    Dialog.fire({
                        html: $("#dimensione_massima").val()
                    })
                }
                if(xhr.responseText) {
                    Dialog.fire({
                        html: xhr.responseText
                    })
                }
            }
        });
    });
})

const clear_fields = (clear_file) => {
    if(clear_file) 
        $("form input:not([type='hidden']), form select").val("");
    else
        $("form input:not([type='file'], [type='hidden']), form select").val("");
    $("form input[type='radio']").prop("checked", false);
}